enum FavoritesListTitles {
  DESAFIO = 'Programas de treino',
  EXERCICIO = 'Exercícios',
  RECEITA = 'Receitas',
  MODALIDADE = 'Saúde e Bem-Estar',
  SUBMODALIDADE = 'Saúde e Bem-Estar',
  TREINO_AGENDADO = 'Treinos Agendados',
}

export { FavoritesListTitles };
